import React from 'react';
import { availabilityTagTypeMap, Product } from 'helper/products';
import Tag from 'components/DesignSystem/Tag';

export function includeIndexToProducts(productsList: Product[]) {
  return productsList.map((product) => {
    const activeString = product.available ? 'a' : 'i';
    return {
      ...product,
      index: `${activeString}-${product.endDateString}`,
    };
  });
}

export function sortProducts(productsList: Product[]) {
  return includeIndexToProducts(productsList)
    .sort((a, b) => a.index.localeCompare(b.index));
}

export default function ProductShortList({ products }: { products: Product[] }) {
  const sortedList = sortProducts(products);
  const tags = sortedList.slice(0, 4)
    .map((product) => (
      <Tag
        key={product.name}
        type={availabilityTagTypeMap[product.availability]}
        className="d-inline-block me-1"
      >
        {product.acronym}
      </Tag>
    ));
  const plus = products.length > 4 && <div className="outline-box">+</div>;
  return (
    <>
      {tags}
      {plus}
    </>
  );
}
